import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=14c8fb3a&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14c8fb3a')) {
      api.createRecord('14c8fb3a', component.options)
    } else {
      api.reload('14c8fb3a', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=14c8fb3a&", function () {
      api.rerender('14c8fb3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-84M1dJx5PSa0X/JS/cancellationPolicy.vue"
export default component.exports